// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { SETTINGS } from './settings';
import * as npm from '../../package.json';

export const environment = {
  production: false,
  appSettings: SETTINGS,
  sampleRestoId:1,
  googleMapApiKey: 'AIzaSyBUr4XGytpsx2jfqOYd1Quv5b7igBI5NzA',
  version: npm.version,


  serverUrl: 'https://stagingapi.foodbud.app/api/auth/',
  baseUrl: 'https://stagingapi.foodbud.app/api/guest/',
  userbaseUrl: 'https://stagingapi.foodbud.app/user/V1/',
  userbaseurlV2:'https://stagingapi.foodbud.app/user/V2/',
  profileUrl: 'https://stagingapi.foodbud.app/profile/V2/',
  mainUrl: 'https://stagingapi.foodbud.app/user/v2/',
  visitorUrl: 'https://stagingapi.foodbud.app/api/guest/trackVisitor',
  googleClientId: '146039020037-nolqoi5fnjed3f6t1foiabqf6t4rl7pa',
  linkUrl: '/#/public/resto',
  sharelinkUrlFb: 'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Ftest.iglulabs.com%2Ftasteprofile_redesign%2Fhome%3Freferal%3D',
  sharelinkUrlwhatapp: 'https://wa.me/?text=http%3A%2F%2Flocalhost:4200%2Fhome%3Freferal%3D',
  sharelinkUrltwitter: 'https://twitter.com/intent/tweet?text=https%3A%2F%2Ftest.iglulabs.com%2Ftasteprofile_redesign%2Fhome%3Freferal%3D',
  quizlinkUrl: 'https://tasteprofile.foodbud.app/home',
  sharelinkUrldecode: 'http://localhost:4201/home?referal=',
  facebookClientId: '2026481171074167',
  googleDirectionKey: 'https://www.google.com/maps/dir/?api=1&',
  paymentgateway_Key: 'pk_test_51KDPt9C9fIZ82NYBP5sU4SkPMuFH9lEvffj5ohd2hfK1t9qcW2t7qI61ogxbp17KTFlqUxeY3znZTSrJOp3IjWdx00fl4zvEB7',
  socialLoginUrl: 'https://stagingapi.foodbud.app/',
  multiCat: 'https://stagingapi.foodbud.app/api/Guest/',
  restaturantUrl: 'https://stagingapi.foodbud.app/restaurant/V1/',




  // serverUrl: 'http://localhost:8000/api/auth/',
  // baseUrl: 'http://localhost:8000/api/guest/',
  // userbaseUrl: 'http://localhost:8000/user/V1/',
  // userbaseurlV2:'http://localhost:8000/user/V2/',
  // profileUrl: 'http://localhost:8000/profile/V2/',
  // mainUrl: 'http://localhost:8000/user/v2/',
  // visitorUrl: 'http://localhost:8000/api/guest/trackVisitor',
  // googleClientId: '146039020037-nolqoi5fnjed3f6t1foiabqf6t4rl7pa',
  // linkUrl: '/#/public/resto',
  // sharelinkUrlFb: 'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Ftest.iglulabs.com%2Ftasteprofile_redesign%2Fhome%3Freferal%3D',
  // sharelinkUrlwhatapp: 'https://wa.me/?text=http%3A%2F%2Flocalhost:4200%2Fhome%3Freferal%3D',
  // sharelinkUrltwitter: 'https://twitter.com/intent/tweet?text=https%3A%2F%2Ftest.iglulabs.com%2Ftasteprofile_redesign%2Fhome%3Freferal%3D',
  // quizlinkUrl: 'https://tasteprofile.foodbud.app/home',
  // sharelinkUrldecode: 'http://localhost:4201/home?referal=',
  // facebookClientId: '2026481171074167',
  // googleDirectionKey: 'https://www.google.com/maps/dir/?api=1&',
  // paymentgateway_Key: 'pk_test_51KDPt9C9fIZ82NYBP5sU4SkPMuFH9lEvffj5ohd2hfK1t9qcW2t7qI61ogxbp17KTFlqUxeY3znZTSrJOp3IjWdx00fl4zvEB7',
  // socialLoginUrl: 'http://localhost:8000/',
  // multiCat: 'http://localhost:8000/api/Guest/',
  // restaturantUrl: 'http://localhost:8000/restaurant/V1/',
};

